<template>
  <div>
    Settings
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {}
    },
    created() {

    },
    mounted() {

    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Settings.vue?fda4c440